import { AccountSearchParams, AccountSearchParamsPost } from '@lk/api/account/models'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const accountSearch = createAsyncThunk<any, Partial<AccountSearchParams>, ThunkApi>(
  '[ACCOUNT_SEARCH] SEARCH',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.search('search', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accountSearchPost = createAsyncThunk<any, Partial<AccountSearchParamsPost>, ThunkApi>(
  '[ACCOUNT_SEARCH] SEARCH_POST',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.searchPost('search', params)
    if (result.success) {
      if (params.instanceName) {
        return {
          instanceName: params.instanceName,
          data: result.data,
        }
      }
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accountSearchPostAgain = createAsyncThunk<any, string, ThunkApi>(
  '[ACCOUNT_SEARCH] SEARCH_POST_AGAIN',
  async (instanceName, { extra, rejectWithValue, getState }) => {
    const params = getState().accountSearch.prevSearchData[instanceName]

    const result = await extra.api.account.searchPost('search', params)
    if (result.success) {
      if (instanceName) {
        return {
          instanceName: instanceName,
          data: result.data,
        }
      }
      return result.data
    }

    // return rejectWithValue(result.error.message)
  },
)

export const accountSearchPrefix = createAsyncThunk<any, Partial<AccountSearchParams>, ThunkApi>(
  '[ACCOUNT_SEARCH] SEARCH_PREFIX',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.search('searchprefix', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accountSearchExact = createAsyncThunk<any, Partial<AccountSearchParams>, ThunkApi>(
  '[ACCOUNT_SEARCH] SEARCH_EXACT',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.search('searchexact', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
